import { render } from "./BlogCategoryPaginator.vue?vue&type=template&id=629d76ac&scoped=true"
import script from "./BlogCategoryPaginator.vue?vue&type=script&lang=js"
export * from "./BlogCategoryPaginator.vue?vue&type=script&lang=js"

import "./BlogCategoryPaginator.vue?vue&type=style&index=0&id=629d76ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629d76ac"]])

export default __exports__